/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailSocialUploadsQueryResponse, GetCompositionsDetailSocialUploadsPathParams } from "../models/GetCompositionsDetailSocialUploads";

export function getGetCompositionsDetailSocialUploadsUrl(id: GetCompositionsDetailSocialUploadsPathParams["id"]) {
  const res = { method: 'GET', url: `/compositions/${id}/social-uploads` as const }
  return res
}

/**
 * @summary List social uploads for a composition
 * {@link /compositions/:id/social-uploads}
 */
export async function getCompositionsDetailSocialUploads(id: GetCompositionsDetailSocialUploadsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetCompositionsDetailSocialUploadsUrl(id).url.toString(), ... requestConfig })
  return res.data
}